import { registerModule } from '../../core/module.js';
import { Products, ProductDetail } from './Products.js';
import { Labels } from './Labels.js';
import { Lists } from './Lists.js';
import { ProductImport } from './Import.js';
import { Promotions } from './Promotions.js';

/** Products, the size and colour grid, barcodes and label printing. */
export default registerModule({
  id: 'catalog',
  order: 30,
  nav: [
    { to: '/products', labelKey: 'nav.products', icon: '👕', group: 'stock', permission: 'catalog.view', order: 1, primary: 6, hintKey: 'nav.hintProducts' },
    { to: '/promotions', labelKey: 'nav.promotions', icon: '🏷', group: 'stock', permission: 'promo.manage', order: 2, hintKey: 'nav.hintPromotions' },
    { to: '/labels', labelKey: 'nav.labels', icon: '🏷', group: 'stock', permission: 'labels.print', order: 5, hintKey: 'nav.hintLabels' },
    { to: '/lists', labelKey: 'nav.lists', icon: '🎨', group: 'stock', permission: 'catalog.edit', order: 6, hintKey: 'nav.hintLists' },
  ],
  routes: [
    { path: '/products', element: <Products />, permission: 'catalog.view', titleKey: 'products.title' },
    { path: '/products/import', element: <ProductImport />, permission: 'catalog.edit', titleKey: 'import.title' },
    { path: '/products/:id', element: <ProductDetail />, permission: 'catalog.view', titleKey: 'products.title' },
    { path: '/promotions', element: <Promotions />, permission: 'promo.manage', titleKey: 'nav.promotions' },
    { path: '/labels', element: <Labels />, permission: 'labels.print', titleKey: 'labels.title' },
    { path: '/lists', element: <Lists />, permission: 'catalog.edit', titleKey: 'lists.title' },
  ],
});
